/**
 * The theme: the stored choice, else the system preference, as `data-theme` on <html>, which
 * selects the dark palette (styles.css). theme-boot.ts applies it before first paint; panel.ts
 * toggles it.
 */
export const THEME_KEY = 'everyferry-theme';

export type Theme = 'light' | 'dark';

function storedTheme(): Theme | null {
  try {
    const value = localStorage.getItem(THEME_KEY);
    return value === 'dark' || value === 'light' ? value : null;
  } catch {
    return null;
  }
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
}

/** The theme to start with. */
export function initialTheme(): Theme {
  return storedTheme() ?? (matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
}
